import { triggerAuthEvent, triggerLoginEvent } from '@shared/event/events/auth'
import { useCustomerStore } from '@shared/global-store/stores/customer/customer'
import { getCustomer } from '@shared/shop-api/customer/api'
import type { Customer } from '@shared/shop-api/customer/types'
import Cookies from 'js-cookie'

export const bootstrapAuthSSR = async (token?: string | null) => {
  const customerStore = useCustomerStore()

  if (!token) {
    return
  }

  customerStore.login(token)

  try {
    const customer = await getCustomer()
    customerStore.setCustomer(customer ?? undefined)
  } catch {
    customerStore.logout()
  }
}

export const bootstrapAuthClient = async () => {
  const customerStore = useCustomerStore()

  const authEvent = getAuthEvent(customerStore.customer)

  const triggerLoggedInEvent = Cookies.get('fo_logged_in') === 'true'

  if (triggerLoggedInEvent && authEvent.isLoggedIn) {
    triggerLoginEvent({
      customer: authEvent.customer,
    })

    Cookies.remove('fo_logged_in')
  }

  if (!triggerLoggedInEvent) {
    triggerAuthEvent(authEvent)
  }
}

const getAuthEvent = (customer: Customer | null) => {
  if (!customer) {
    return {
      isLoggedIn: false,
      customer: undefined,
    } as const
  }

  return { isLoggedIn: true, customer } as const
}
